function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 476.713,
    height: 358.9,
    viewBox: "0 0 476.713 358.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4s5rlwwhca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 597",
    style: {
      fill: "none"
    },
    d: "M0 0h476.713v358.9H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ujh9v3qelb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 592",
    transform: "translate(0 270.331)",
    style: {
      fill: "none"
    },
    d: "M0 0h474.18v88.569H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bhiy2f84xc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 593",
    transform: "translate(50.848 288.427)",
    style: {
      fill: "none"
    },
    d: "M0 0h368.087v45.281H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1l0smlvxud"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 594",
    transform: "translate(170.131 299.448)",
    style: {
      fill: "none"
    },
    d: "M0 0h142.537v22.466H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2237",
    style: {
      clipPath: "url(#4s5rlwwhca)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2236"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2235",
    style: {
      clipPath: "url(#4s5rlwwhca)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2228",
    style: {
      opacity: 0.44,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2227"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2226",
    style: {
      clipPath: "url(#ujh9v3qelb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3397",
    d: "M453.575 298.353a156.276 156.276 0 0 0-41.586-19.126c-31.819-9.537-65.434-10.107-98.322-7.682-8.069.6-16.121 1.378-24.167 2.233a.739.739 0 0 0-.611-.848.814.814 0 0 0-.121-.009c-35.3-.346-70.6-.69-105.894.029-35.093.714-70.191 2.48-105.089 6.339-15.271 1.689-30.735 3.412-45.5 7.828a95.256 95.256 0 0 0-20.029 8.383c-4.731 2.7-12.5 6.755-12.25 13.2.235 6.028 6.983 9.188 11.726 11.216a237.744 237.744 0 0 0 22.583 8.3 353.7 353.7 0 0 0 48.3 11.053c33.768 5.543 68 8.686 102.1 11.287 35.241 2.687 70.549 4.391 105.867 5.711q26.493.99 53 1.768c16.779.516 33.579 1.181 50.366.69 16.1-.47 32.255-2.039 47.9-6 11.784-2.985 29.042-7.251 31.882-21.271 2.952-14.67-9.185-25.827-20.155-33.1m17.706 35.8c-2.751 6.691-9.529 10.394-15.965 12.823-14.7 5.546-30.559 8.133-46.154 9.389-15.825 1.274-31.725 1.09-47.583.661q-25.044-.676-50.087-1.564c-33.776-1.14-67.548-2.524-101.279-4.673-33.765-2.151-67.5-5.057-101.068-9.28-31.511-3.965-63.222-9.376-92.811-21.336-5.144-2.079-16.874-5.888-14.514-13.6 1.149-3.755 5.408-6.168 8.519-8.122a80.485 80.485 0 0 1 9.3-5c13.461-6.16 28.247-8.842 42.826-10.776 33.141-4.4 66.589-6.533 99.99-7.638 33.888-1.121 67.8-1.074 101.7-.8q11.533.094 23.067.213c-.193.478.019 1.1.661 1.035 32.93-3.545 66.469-5.842 99.328-.379a183.094 183.094 0 0 1 43.739 12.7 146.907 146.907 0 0 1 19.442 10.321c6.383 4.045 12.844 8.579 17.28 14.816 4.275 6.008 6.516 14.133 3.609 21.209z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2231",
    style: {
      opacity: 0.44,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2230"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2229",
    style: {
      clipPath: "url(#bhiy2f84xc)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3398",
    d: "M418.606 320.1c-1.293-4.284-5.314-7.572-9.035-9.734-20.128-11.7-43.289-18.7-66.384-21.062a169.958 169.958 0 0 0-17.254-.872.773.773 0 1 0 0 1.546 169.543 169.543 0 0 1 66.852 13.778 164.381 164.381 0 0 1 15.208 7.492c3.886 2.176 9.466 6.089 9.42 11.134-.055 6.143-9.062 7.26-13.578 8.077a115.735 115.735 0 0 1-18.2 1.549c-24.872.516-49.8.223-74.674.038-25.025-.186-50.05-.619-75.062-1.494-25.112-.878-50.21-2.2-75.26-4.165q-18.693-1.465-37.343-3.429c-12.313-1.3-24.665-2.619-36.893-4.586a165.91 165.91 0 0 1-17.286-3.627c-5.021-1.369-11.3-2.647-15.009-6.591-1.846-1.963-2.742-4.982.008-6.666 2.244-1.374 5.382-1.4 7.916-1.757q9.527-1.331 19.089-2.362c24.83-2.7 49.785-4.056 74.741-4.862 25.256-.816 50.531-1.192 75.8-1.345q37.854-.23 75.7.39 9.281.152 18.559.355a.773.773 0 0 0 0-1.545q-39.663-.864-79.339-.8-39.42.066-78.835 1.057c-26.163.683-52.333 1.829-78.391 4.36q-9.855.957-19.677 2.193-4.57.578-9.128 1.223c-2.394.339-5.092.473-7.214 1.762-3.645 2.214-2.878 6.385-.321 9.093 3.588 3.8 9.221 5.14 14.057 6.531 11.79 3.391 24.006 4.949 36.152 6.436q19.331 2.368 38.73 4.133c26.1 2.392 52.259 4.036 78.44 5.151 26.2 1.117 52.426 1.7 78.651 1.987 26.109.281 52.221.259 78.331.15 6.3-.026 12.6-.051 18.878-.622 5.637-.512 11.685-1.24 16.958-3.4 3.913-1.613 6.708-5.157 5.393-9.516",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2234",
    style: {
      opacity: 0.44,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2233"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2232",
    style: {
      clipPath: "url(#1l0smlvxud)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3399",
    d: "M310.292 309.4a53.685 53.685 0 0 0-6.489-2.419q-3.5-1.159-7.082-2.067a105.182 105.182 0 0 0-14.716-2.629q-3.579-.381-7.176-.513a.659.659 0 0 0-.659.393 281.841 281.841 0 0 0-90.148 1.954c-2.39.44-4.829.821-7.18 1.437a12.505 12.505 0 0 0-4.71 2.29 4.689 4.689 0 0 0-2 3.948 4.459 4.459 0 0 0 2.931 3.587 24.476 24.476 0 0 0 6.02 1.229q3.848.563 7.7 1.067 7.787 1.02 15.6 1.793 15.532 1.539 31.14 2.109a500.862 500.862 0 0 0 62.75-1.643c4.062-.362 8.418-.544 12.112-2.463 1.6-.83 3.441-2.182 4.089-3.936.691-1.874-.568-3.357-2.183-4.137m-.73 5.431c-2.964 2.6-7.274 3-11.025 3.352a501.063 501.063 0 0 1-117.917-2.9 41.26 41.26 0 0 1-6.291-1.079c-1.482-.458-3.169-1.673-2.547-3.457.533-1.531 2.291-2.5 3.687-3.094a29.792 29.792 0 0 1 6.042-1.488 278.915 278.915 0 0 1 28.872-4.082 281.945 281.945 0 0 1 57.9.85q3.591.426 7.168.945a.815.815 0 0 0 .863-.477 103.371 103.371 0 0 1 26.219 4.792 65.682 65.682 0 0 1 6.734 2.43c.685.306 1.613.743 1.832 1.538.283 1.03-.861 2.073-1.543 2.669z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3400",
    d: "M368.381 122.815a50.985 50.985 0 0 0 10.689-16.94 9.152 9.152 0 0 0 .877-3.721 9.5 9.5 0 0 0-.715-2.852c-2.035-5.521-4.818-10.674-7.008-16.107-.68-1.689-.613-3.054-2.428-3.815-2.077-.871-5.092.491-6.75 1.684-6.234 4.487-8.488 12.6-10.1 20.116-.828 3.853-1.033 8.5-2.542 12.128-1.3 3.124-2.988 5.513-3.206 9.118-.274 4.531 1.734 10.565 7.1 9.22 5.286-1.325 10.318-5.013 14.083-8.831",
    style: {
      fill: "#362985"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 132",
    transform: "translate(353.925 188.904)",
    style: {
      strokeWidth: "3.492px",
      strokeMiterlimit: 10,
      stroke: "#ddb89a",
      fill: "none"
    },
    d: "M68.695 0 0 47.912"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3401",
    d: "M389.08 199.1c3.725 0 6.744 4.817 6.744 10.758s-3.019 10.758-6.744 10.758-6.744-4.817-6.744-10.758 3.019-10.758 6.744-10.758",
    style: {
      fill: "#584545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3402",
    d: "M288.475 286.99c.881 0 1.6 1.039 1.6 2.321s-.715 2.321-1.6 2.321-1.6-1.039-1.6-2.321.715-2.321 1.6-2.321",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3403",
    d: "m433.681 66.534 37.647 9.628s-1.354 8.358-1.38 11.038-1.5 89.531-1.5 89.531l-39.6 18.112z",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3404",
    d: "M318.23 232.813v-74.294a23.747 23.747 0 0 1 21.278-23.2l66.14-5.89",
    style: {
      strokeWidth: "6.984px",
      stroke: "#3f3138",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 133",
    transform: "translate(349.63 129.432)",
    style: {
      strokeWidth: "20.951px",
      strokeLinecap: "round",
      stroke: "#222",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 4.988 56.02 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3405",
    d: "m303.174 220.814 65.46 9.562 95.729-9.562-60.163-25.972 4.143-43.639-90.112 13.439.41 46.81z",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3406",
    d: "M355.9 287.137c-.224-4.753-2.12-9.855-.828-14.491-.045.161-9.709.738-10.709.969-2.311.534-3.422 1.138-4.388 3.3-1.088 2.441-1.4 4.857-3.063 7.089-2.068 2.781-5.018 4.755-7.592 7.021a41.636 41.636 0 0 0-5.014 5.3c11.039 5.847 21.983-2.173 31.594-9.183",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3407",
    d: "M324.306 296.324a41.623 41.623 0 0 0-3.311 4.75c-.99 1.668-1.865 3.78-.908 5.467.975 1.716 3.3 2.021 5.271 1.9 8-.5 15.235-4.719 22.127-8.824 2.842-1.694 5.831-3.537 7.333-6.487a11.668 11.668 0 0 0 1.081-5.99c-9.61 7.007-20.555 15.027-31.593 9.184",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3408",
    d: "M322.149 277.018c-.225-4.753-2.121-9.854-.828-14.492-.045.162-9.708.738-10.709.969-2.311.534-3.421 1.138-4.388 3.3-1.088 2.441-1.4 4.858-3.063 7.089-2.067 2.781-5.018 4.755-7.591 7.021a41.687 41.687 0 0 0-5.015 5.3c11.039 5.842 21.982-2.178 31.594-9.187",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3409",
    d: "M290.554 286.2a41.754 41.754 0 0 0-3.311 4.75c-.989 1.668-1.865 3.781-.907 5.467.975 1.716 3.3 2.021 5.271 1.9 8-.5 15.236-4.719 22.128-8.824 2.844-1.693 5.831-3.537 7.334-6.487a11.688 11.688 0 0 0 1.081-5.99c-9.612 7.007-20.557 15.027-31.6 9.184",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3410",
    d: "M347.346 165.651a113.406 113.406 0 0 0-20.129 4.949c-4.977 1.723-12.3 3.432-15.935 7.364-8.835 9.565-12.658 23.882-14.813 36.366-2.493 14.431 3.194 37.9-.309 52.122a40.485 40.485 0 0 0 28.038 1.98c4.09-15.1 1.136-39.116 3.562-54.569 1.184-7.531 2.573-11.775 9.91-14.164q5.892-1.919 11.936-3.305c2.614-.6 8.771-.511 10.821-2.033-7.013 5.207-17.325 10.489-22.458 17.487-5.252 7.159-6.383 16.449-7.3 25.014-1.146 10.7 4.048 30.114 3.021 40.827a72.614 72.614 0 0 0 26.424 1.091c1.492-7.005 1.209-14.256 1.958-21.379s-3.477-23.21 1.613-28.244c4.425-4.376 10.526-6.309 16.52-7.326 6.21-1.054 11.93-2.5 18.318-2.875a251.6 251.6 0 0 0 42.083-6.084c4.01-.931 9.913-1.307 12.842-4.379 3.18-3.335 4.544-8.435 4.155-12.948-.52-6.047-3.842-11.6-8.215-15.8s-9.75-7.2-15.2-9.851c-9.451-4.587-19.437-8.29-29.849-9.678-10.167-1.358-46.945 3.915-56.992 5.435",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3411",
    d: "M461.989 170.587c.279-11.868 1.548-24.255-1.413-35.865-5.949-23.332-16.532-47.032-36.563-60.362a62.2 62.2 0 0 0-16.8-7.853c-5.4-1.6-11.193-2.447-16.662-1.1-8.589 2.119-14.968 9.214-20.254 16.315-1.609 2.16-3.224 4.494-3.48 7.176a11.3 11.3 0 0 0 1.314 5.9c2.665 5.507 7.63 9.53 10.995 14.638 10.057 15.27 4.7 37.431-3.163 52.391 19.84 39.517 51.164 29.3 81.742 29.758a23.656 23.656 0 0 0 1.33-2.476c2.614-5.73 2.806-12.228 2.954-18.527",
    style: {
      fill: "#473b8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3412",
    d: "m377.3 227.745 90.978-8.1.34 3.825-90.979 8.1",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3413",
    d: "M381.031 306.57v-124.3a23.746 23.746 0 0 1 21.278-23.2l66.14-5.89",
    style: {
      stroke: "#2e2365",
      strokeWidth: "6.984px",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 134",
    transform: "translate(466.238 170.663)",
    style: {
      stroke: "#2e2365",
      strokeWidth: "6.984px",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 124.3V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 135",
    transform: "translate(412.425 153.381)",
    style: {
      stroke: "#2e2365",
      strokeWidth: "20.951px",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 4.792 53.813 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3414",
    d: "M378.283 89.368a11.725 11.725 0 0 0 6.918-3.973 21.754 21.754 0 0 0 5.735-16.265l-14.6 12.437c-1.717 1.463-4.953 2.974-4.128 5.229.746 2.049 4.246 2.785 6.075 2.572",
    style: {
      fill: "#e7a579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3415",
    d: "M344.324 74.948c-.391 1.163-.858 2.583-.042 3.5s2.851 1.769 3.957 2.4a10.353 10.353 0 0 0 5.32 1.593 3.791 3.791 0 0 0 1.4-.263 4.291 4.291 0 0 0 2.029-2.394 20.562 20.562 0 0 0 1.084-9.379c-.51-5.265-1.229-10.682-3.9-15.248a9.178 9.178 0 0 0-4.265-4.132 6.307 6.307 0 0 0-6.641 1.471 6.673 6.673 0 0 0-1.842 5.379c.254 1.635 1.827 3.031 2.463 4.6a18.143 18.143 0 0 1 .437 12.473",
    style: {
      fill: "#f3e6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3416",
    d: "M347.022 67.165c2.312 9.694 9.983 18.855 19.912 19.56 6.713.477 13.146-2.9 18.36-7.164 5.542-4.526 10.268-10.3 12.475-17.114 4.041-12.465-1.837-27.394-13.286-33.747-9.947-5.52-25.034-4.321-33.232 4.071-7.026 7.192-6.352 25.493-4.229 34.394",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3417",
    d: "M360.028 48.142c-6.941 2.12-14.241 6.006-16.439 12.929-5.907-6.507-4.871-17.369.644-24.213s14.384-10.184 23.1-11.28a34.059 34.059 0 0 1 13.691.724c5.51 1.6 8.975 3.77 4.743 8.986-6.306 7.771-16.634 10.074-25.739 12.854",
    style: {
      fill: "#f3e6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3418",
    d: "M382.139 45.214q.047.565.115 1.124c.594 4.773 2.32 9.325 3.323 14.029s1.215 9.85-1.058 14.087a51.208 51.208 0 0 0 6.258 1.344c6.469.462 12.522-5.542 14.088-11.512 1.827-6.966-1.228-15.9-4.509-21.838-2.669-4.833-4.342-11.591-11.386-12.087-2.764-.195-4.626 3.781-5.571 5.946a18.645 18.645 0 0 0-1.26 8.907",
    style: {
      fill: "#f3e6dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3419",
    d: "M360.317 60.962a21.33 21.33 0 0 1-.659 6.536 3.819 3.819 0 0 0-.144 2.4c.469 1.125 1.891 1.424 3.1 1.57",
    style: {
      strokeWidth: "2.619px",
      strokeLinejoin: "round",
      stroke: "#e5a579",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3420",
    d: "M349.653 60.169a4.174 4.174 0 0 1 3.713-.691",
    style: {
      stroke: "#1f3d52",
      strokeWidth: "2.619px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3421",
    d: "M369.586 59.089a4.211 4.211 0 0 1 4.863.294",
    style: {
      stroke: "#1f3d52",
      strokeWidth: "2.619px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3422",
    d: "M368.191 52.644a10.912 10.912 0 0 1 9.185.935",
    style: {
      stroke: "#f6ece4",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: "3.492px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3423",
    d: "M348.675 55.2a5.857 5.857 0 0 1 5.5-.753",
    style: {
      stroke: "#f6ece4",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: "3.492px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 136",
    transform: "translate(359.055 75.693)",
    style: {
      strokeWidth: "2.619px",
      strokeLinejoin: "round",
      stroke: "#e5a579",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m0 0 6.146.072"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3424",
    d: "M360.683 77.357a4.363 4.363 0 0 0 3.966-.289",
    style: {
      strokeWidth: "2.619px",
      strokeLinejoin: "round",
      stroke: "#e5a579",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3425",
    d: "M174.993 99.294a75.907 75.907 0 0 1 4.7 16.636 12.7 12.7 0 0 1 .009 4.261 13.679 13.679 0 0 1-2.235 4.632 82.47 82.47 0 0 1-10.541 12.834 9.985 9.985 0 0 1-4.289 2.909c-2.033.527-4.152-.186-6.173-.754a45.424 45.424 0 0 0-14.043-1.652 95.053 95.053 0 0 1 17.945-18.785l-11.3-18.577c-2.643-4.344-5.327-8.789-6.428-13.754a23.269 23.269 0 0 1 2.183-15.475c1.559-3.054 7.49-11.682 11.774-10.943 3.672.633 8.209 14.515 9.755 17.9q4.674 10.234 8.643 20.768",
    style: {
      fill: "#b0bc30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3426",
    d: "M157.867 127.838a32.1 32.1 0 0 1 5.328-6.048 15.727 15.727 0 0 1 5.75-3.309 19.994 19.994 0 0 1-7.236-6.233c-1.853-2.407-3.414-5.019-5.055-7.57-1.888-2.935-3.966-5.746-5.923-8.634a96.583 96.583 0 0 1-8.545-14.825 21.457 21.457 0 0 0 .457 5.824c1.1 4.965 3.786 9.411 6.427 13.754l11.3 18.577a95.081 95.081 0 0 0-17.945 18.785 45.389 45.389 0 0 1 9.819.707 44.742 44.742 0 0 1 5.623-11.028",
    style: {
      fill: "#99a834"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 137",
    transform: "translate(37.278 188.527)",
    style: {
      strokeWidth: "16.861px",
      stroke: "#2e2365",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M8.448 0 0 102.027"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3427",
    d: "M35.08 53.728s16.627 65.631 10.646 134.8",
    style: {
      strokeWidth: "16.861px",
      strokeLinejoin: "round",
      stroke: "#2e2365",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3428",
    d: "m38.154 67.923 68.675-16.331 2.254 37.59-65.061 17.036s-4.485-31.519-5.868-38.3",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3429",
    d: "m173.471 188.527 2.253 16.743-77.493 27.072v-44.205z",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3430",
    d: "M98.231 188.137v44.205l-57.179-35.056v-9.446z",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3431",
    d: "m142.5 162.507 50.01 28.816-94.276 30.3-57.179-33.78z",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3432",
    d: "M142.5 157.567c16.418 3.822 33.242 9.234 44.767 20.607 14.394 14.2 17.829 35.162 16.3 54.494-.873 11.009-3.121 21.866-5.1 32.738-1.033 5.661-2.009 11.335-2.683 17.044-.684 5.8-.57 7.371-7.451 8.548-8.042 1.376-16.409 2.744-24.314.817a8.2 8.2 0 0 1-4.13-2.016c-1.867-2-.559-7.926-.247-10.411q3.109-24.8 6.222-49.6c.574-4.58 1.144-9.265.032-13.762-1.689-6.836-7.149-12.487-13.55-16.325-6.366-3.816-13.643-6.078-20.8-8.283 8.19 9.412 19.607 17.415 24.647 28.992 5.084 11.676 3.174 24.875.012 37.107-1.592 6.158-3.482 16.306-4.92 22.5a62.194 62.194 0 0 0-1.815 9.965c-.158 2.5 1.084 5.315-.9 7.425a10.182 10.182 0 0 1-4.738 2.492 35.763 35.763 0 0 1-16.084.334 92.484 92.484 0 0 1-15.41-4.673c-1.945-.729 1.221-22.441 1.389-24.36.406-4.629 6.7-49.605 4.547-50.344-10.205-3.506-18.253-8.992-27.622-13.721-8.337-4.209-15.359-7.478-21.548-14.6-2.731-3.143-5.169-6.749-5.462-10.758-.877-11.959 10.818-16.664 21-20.532 10.5-3.99 23.618-7.566 35.13-6.853 7.441.462 15.184 2.255 22.732 3.175",
    style: {
      fill: "#473b8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3433",
    d: "m143.886 293.287 9.125 12.2a6.934 6.934 0 0 1 1.78 3.854 4.533 4.533 0 0 1-2.836 3.926 10.663 10.663 0 0 1-5.034.63 36 36 0 0 1-27.741-16.383 11.408 11.408 0 0 1-1.965-4.852 4.912 4.912 0 0 1 1.939-4.631z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3434",
    d: "m187.74 290.642 9.125 12.2a6.934 6.934 0 0 1 1.78 3.854 4.533 4.533 0 0 1-2.836 3.927 10.651 10.651 0 0 1-5.034.629 35.993 35.993 0 0 1-27.741-16.383 11.4 11.4 0 0 1-1.966-4.852 4.912 4.912 0 0 1 1.939-4.631z",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3435",
    d: "M131.968 46.023a35.187 35.187 0 0 0-11.52-.5 60.177 60.177 0 0 0-32 13.159c-6.266 5.185-11.073 11.926-15.159 18.962a133.6 133.6 0 0 0-17.952 64.879c-.1 7.007.793 13.666.23 20.566a44.161 44.161 0 0 0 4.728 22.559 9.455 9.455 0 0 0 2.733 3.663 8.3 8.3 0 0 0 5.129 1.2c6.586-.226 12.544-3.775 18.877-5.6 6.822-1.966 14.048-1.915 21.04-3.141 3.077-.539 41.035-11.722 40.283-14.229-5.369-17.9-6.255-33.9-.646-52.022 3.456-11.168 8.039-22.046 10.07-33.559 1.645-9.318.209-17.488-6.567-24.336-5.964-6.032-12.087-10.029-19.246-11.6",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3436",
    d: "M157.787 81.959c1.4-7.917.557-15-3.881-21.156a50.805 50.805 0 0 1-.129 15.018 74.778 74.778 0 0 1-3.17 10.783c-1.258 3.582-2.661 7.112-4.146 10.6-2.9 6.839-6.18 13.5-9.347 20.22-2.9 6.154-5.67 12.372-8.809 18.41a94.211 94.211 0 0 1-10.768 16.839c-4.686 5.651-10.547 10.243-16.363 14.664-6.292 4.782-12.8 9.281-18.979 14.206-3.707 2.953-7.454 5.858-11.271 8.666 5.519-.914 10.681-3.739 16.118-5.306 6.821-1.966 14.047-1.915 21.04-3.141 3.077-.539 41.035-11.722 40.283-14.229-5.37-17.9-6.255-33.9-.646-52.022 3.453-11.161 8.035-22.037 10.068-33.552",
    style: {
      fill: "#b0bc36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3437",
    d: "m145.325 73.3-6.263-4.378a2.391 2.391 0 0 0-1.119-.521 2.417 2.417 0 0 0-1.6.718l-8.28 6.59c-7.623-6.958-12.453-19.089-13.38-29.375-.054-.61 16.774-3.223 13.662 0-2.131 2.208 1.193 2.622 4.074 3.673 4.792 1.75 12.535 3.39 13.592 8.837a34.143 34.143 0 0 1-.686 14.456",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3438",
    d: "M135.43 65.425c-4.493.618-8.6-2.753-10.206-6.9a24.687 24.687 0 0 1-.235-17.062 3.85 3.85 0 0 1 1.613-2.29c1.336-.675 2.872.3 3.948 1.325 2.1 2 5.289 2.63 7.764 3.969A15.844 15.844 0 0 1 145.3 52.7a12.288 12.288 0 0 0 1.449 3.376c1.28 1.575 3.183 2.135 4.522 3.648q-2.208.75-4.4 1.535a24.954 24.954 0 0 1-3.519.8c-2.232.476-4.031 2.122-6.147 2.915a8.212 8.212 0 0 1-1.766.453",
    style: {
      fill: "#e7a579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3439",
    d: "M165.914 50.9a30.2 30.2 0 0 1-1.828 3.008c-1.323 1.913-2.837 4.132-5.032 5.189-2.741 1.32-6.014 1.357-8.954 1.091-5.909-.533-11.879-2.055-16.642-5.6a19.706 19.706 0 0 1-6.381-8.043 17.282 17.282 0 0 1-1.271-5.229 32.255 32.255 0 0 0-1.188-4.713c-1.812-7.63-1.289-16.392 3.083-23.151 3.2-4.94 9.271-7.317 15.048-7.443a43.112 43.112 0 0 1 16.042 2.559c2.22.833 4.152 2.053 6.331 2.932 2.146.865 4.313 2.089 5.381 4.269 2.061 4.2.737 8.894-.38 13.111-.8 3.035-.5 6.228-.669 9.358a30.763 30.763 0 0 1-3.54 12.662",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3440",
    d: "M171.337 16.648c-3.193 2.2-9.455 1.016-12.664.195-4.6-1.179-8.963-3.182-13.605-4.186a9.38 9.38 0 0 0-6.073.249c-2.546 1.24-3.768 4.279-3.9 7.109-.133 2.854.483 5.676.449 8.514a26.466 26.466 0 0 0 1.289 7.9 29.829 29.829 0 0 0 8.476 13.41 9.342 9.342 0 0 1 5.688-4.4 22.8 22.8 0 0 1 7.32-.7c2.417.065 7.381.26 8.338 3.136.319.958-.165 2.144-.326 3.089-.316 1.842-.516 3.71-.768 5.562-.263 1.925-.585 3.983-1.912 5.4-1.6 1.709-4.174 1.988-6.515 2.061a71.467 71.467 0 0 1-11.242-.494c-5.986-.764-12.325-2.713-15.872-7.6a27.09 27.09 0 0 1-2.534-4.677c-3.044-6.623-7.015-14.421-7.053-21.84a55.074 55.074 0 0 1 2.18-14.28c1.244-4.706 2.978-9.68 6.926-12.522C133.97-.617 139.928-.243 145.288.55c2.414.854 5.189.79 7.652 1.615 2.928.98 6.369 1.154 9.415 1.68 4.982.861 10.719 3.119 11.2 8.92.16 1.945-.727 2.855-2.218 3.883",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3441",
    d: "M161.556 31.034q.879 3.833 1.76 7.663a5.545 5.545 0 0 1 .126 2.979 1.869 1.869 0 0 1-2.29 1.32l-.024-.007",
    style: {
      strokeWidth: "2.494px",
      strokeLinejoin: "round",
      stroke: "#e5a579",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3442",
    d: "M169.5 28.283a12.836 12.836 0 0 0-5.76-1.236",
    style: {
      stroke: "#8f6d56",
      strokeWidth: "6.323px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3443",
    d: "M154.856 26c-2.567-1.19-6.146-.459-8.85.448",
    style: {
      stroke: "#8f6d56",
      strokeWidth: "6.323px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3444",
    d: "M164.946 32.154a.205.205 0 0 1-.136-.037c-.077-.068-.019-.193.045-.273a2.657 2.657 0 0 1 1.535-.993 1.7 1.7 0 0 1 1.668.6c.56.765-.156.81-.736.789z",
    style: {
      fill: "#584545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3445",
    d: "M148.917 32.121a.263.263 0 0 1-.174-.028c-.1-.075-.049-.239.02-.347a3.33 3.33 0 0 1 1.783-1.445 2.135 2.135 0 0 1 2.161.519c.8.88-.085 1.032-.812 1.084q-1.49.107-2.978.217",
    style: {
      fill: "#584545"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3446",
    d: "M172.872 38.9q-.138.108-.288.213a6 6 0 0 1-5.9.558 5.5 5.5 0 0 1-2.942-3.753c-.308-1.526-.068-4.818 1.679-5.5 2.139-.838 5.2-.373 7.259.211a4.593 4.593 0 0 1 2.206 1.178c.764.84.586 1.8.338 2.853a7.2 7.2 0 0 1-2.352 4.24z",
    style: {
      strokeWidth: "2.57px",
      stroke: "#eb6626",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3447",
    d: "M156.491 37.163a5.967 5.967 0 0 1-.288.213 6 6 0 0 1-5.9.558 5.5 5.5 0 0 1-2.942-3.753c-.308-1.526-.068-4.818 1.68-5.5 2.139-.838 5.2-.373 7.259.211a4.593 4.593 0 0 1 2.206 1.178c.764.84.587 1.8.338 2.853a7.2 7.2 0 0 1-2.353 4.24z",
    style: {
      strokeWidth: "2.57px",
      stroke: "#eb6626",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3448",
    d: "M163.756 33.127a4.017 4.017 0 0 0-4.691-.426",
    style: {
      stroke: "#fff",
      strokeWidth: "2.57px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 138",
    transform: "translate(133.786 28.325)",
    style: {
      strokeWidth: "2.57px",
      stroke: "#eb6626",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M13.784 2.27 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3449",
    d: "M132.194 27.539a2.188 2.188 0 0 0-2.76 1.088 2.845 2.845 0 0 0 .347 2.2 8.341 8.341 0 0 0 3.842 3.709.386.386 0 0 0 .319.046.362.362 0 0 0 .158-.2 5.14 5.14 0 0 0 .291-1.88c.059-2.042.161-4.13-2.2-4.963",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3450",
    d: "M157.8 46.282a4.9 4.9 0 0 0-3.221 3.738 1.294 1.294 0 0 0 .05.7 1.376 1.376 0 0 0 .63.586 10.369 10.369 0 0 0 6.162.911 3.872 3.872 0 0 0 1.634-.441 2.7 2.7 0 0 0 1.092-2.726c-.5-3.06-3.783-3.7-6.347-2.768",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3451",
    d: "m98.623 326.552-7.7-.5 4.86-146.06 7.877-1.539z",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3452",
    d: "m399.267 335.992-6.656-150.9 8.783.282 5.585 150.276z",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3453",
    d: "M351.574 119.74H182.636l-6.707 8.057 1.925.054-1.925-.054-2.013 2.419 2.013-2.419-14.155-.394L95.3 180.191l306.1 5.182z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3454",
    d: "m99.247 187.715 297.19 4.027V184.2L99.75 179.161z",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 595",
    transform: "translate(186.906 164.796)",
    style: {
      fill: "#2b211a"
    },
    d: "M0 0h146.021v4.823H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3455",
    d: "m236.973 143.043 1.741-5.438h-11.4l-2.344 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3456",
    d: "m248.977 143.043 1.121-5.438h-11.383l-1.741 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3457",
    d: "M227.319 137.605h-11.406l-2.936 5.438h12z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3458",
    d: "m297.023 143.043-1.511-5.438h-11.333l.828 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3459",
    d: "m285.005 143.043-.828-5.438h-11.348l.163 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3460",
    d: "m272.993 143.043-.163-5.438h-11.36l-.487 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3461",
    d: "m260.983 143.043.487-5.438H250.1l-1.122 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3462",
    d: "m286.662 153.919.829 5.438h14.065l-1.512-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3463",
    d: "m260.008 153.919-.487 5.438h13.958l-.162-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3464",
    d: "m273.318 153.919.162 5.438h14.011l-.829-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3465",
    d: "m246.733 153.919-1.121 5.438h13.9l.488-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3466",
    d: "m220.284 153.919-2.346 5.438h13.814l1.74-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3467",
    d: "m207.106 153.919-2.936 5.438h13.769l2.346-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3468",
    d: "m233.492 153.919-1.74 5.438h13.859l1.122-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3469",
    d: "M222.629 148.481h-12.588l-2.936 5.438h13.178z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3470",
    d: "M224.974 143.043h-12l-2.936 5.438h12.6z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3471",
    d: "m247.854 148.481 1.122-5.438h-12l-1.74 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3472",
    d: "M236.974 143.043h-12l-2.346 5.438h12.6z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3473",
    d: "m260.495 148.481.487-5.438h-12.006l-1.122 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3474",
    d: "m273.154 148.481-.163-5.438h-12.009l-.487 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3475",
    d: "m298.532 148.481-1.511-5.438H285l.828 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3476",
    d: "m222.628 148.481-2.345 5.438h13.209l1.741-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3477",
    d: "m285.835 148.481-.829-5.438h-12.014l.163 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3478",
    d: "m260.5 148.481-.487 5.438h13.307l-.163-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3479",
    d: "M300.045 153.919h13.42l-2.211-5.438h-12.721z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3480",
    d: "M298.533 148.481h12.721l-2.212-5.438h-12.02z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3481",
    d: "m285.834 148.481.828 5.438h13.382l-1.512-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3482",
    d: "m247.855 148.481-1.121 5.438h13.275l.487-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3483",
    d: "m309.043 143.043-2.211-5.438h-11.321l1.511 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3484",
    d: "m273.155 148.481.163 5.438h13.344l-.828-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3485",
    d: "m235.233 148.481-1.741 5.438h13.241l1.122-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3486",
    d: "m204.166 159.358-2.936 5.442h14.359l2.346-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3487",
    d: "m231.752 159.358-1.741 5.438h14.479l1.122-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3488",
    d: "m190.445 159.358-3.513 5.438h14.3l2.936-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3489",
    d: "m217.939 159.358-2.345 5.438h14.418l1.742-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3490",
    d: "M212.973 143.043h-11.994l-3.513 5.438h12.569z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3491",
    d: "m300.043 153.919 1.511 5.438h14.121l-2.212-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3492",
    d: "M207.1 153.919h-13.143l-3.513 5.438h13.725z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3493",
    d: "m273.48 159.358.163 5.438h14.68l-.83-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3494",
    d: "m301.555 159.358 1.514 5.438h14.821l-2.211-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3495",
    d: "M329.856 159.358h-14.178l2.211 5.438h14.9z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3496",
    d: "m245.612 159.358-1.122 5.442h14.543l.487-5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3497",
    d: "m259.521 159.358-.487 5.438h14.609l-.163-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3498",
    d: "M215.914 137.605H204.5l-3.513 5.438h11.994z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3499",
    d: "m287.492 159.358.828 5.438h14.748l-1.511-5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3500",
    d: "M210.042 148.481h-12.57l-3.514 5.438h13.148z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3501",
    d: "m318.137 137.605-2.93-5.438h-10.588l2.211 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3502",
    d: "m306.836 137.605-2.211-5.438h-10.62l1.511 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3503",
    d: "M309.046 143.043h12.025l-2.929-5.438h-11.306z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3504",
    d: "m295.51 137.605-1.51-5.438h-10.652l.829 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3505",
    d: "M311.254 148.481H324l-2.93-5.438h-12.028z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3506",
    d: "M315.673 159.357h14.178l-2.929-5.438H313.46z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3507",
    d: "M313.465 153.919h13.462L324 148.481h-12.746z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3508",
    d: "m227.319 137.605 2.345-5.438h-10.815l-2.937 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3509",
    d: "m238.714 137.605 1.741-5.438h-10.791l-2.345 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3510",
    d: "M218.85 132.167h-10.839l-3.514 5.438h11.416z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3511",
    d: "m250.1 137.605 1.122-5.438h-10.767l-1.74 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3512",
    d: "m272.83 137.605-.163-5.438h-10.709l-.488 5.438z",
    style: {
      fill: "#465d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3513",
    d: "m261.471 137.605.488-5.438H251.22l-1.122 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3514",
    d: "m284.177 137.605-.829-5.438h-10.681l.163 5.438z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3515",
    d: "M286.182 122.7a7.95 7.95 0 0 0-.186.176.5.5 0 0 0-.064.462 2.114 2.114 0 0 0 .8 1.548 2.252 2.252 0 0 0 1.5.054 1.74 1.74 0 0 1 1.465.206 5.556 5.556 0 0 0-2.248 3.045 2.624 2.624 0 0 0 1.069 2.884 4.6 4.6 0 0 0-1.924 1.573 1.642 1.642 0 0 0-.337 1.494 1.691 1.691 0 0 0 1.3.849 9 9 0 0 0 2 .15 21.6 21.6 0 0 0 4.743-.6 3 3 0 0 0-2.477-3.088 2.626 2.626 0 0 0 .759-.887l.995-1.59a11.733 11.733 0 0 0 .881-1.59 8.713 8.713 0 0 0 .555-3.662 3.541 3.541 0 0 0-.563-2.109 3.446 3.446 0 0 0-1.525-.974c-.279-.111-.528-.266-.8-.373-.11-.043-.9-.1-.917-.126a3.4 3.4 0 0 0-2.043-1.511l.058 1.732a.319.319 0 0 1-.214.364 17.437 17.437 0 0 0-2.827 1.973",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3516",
    d: "M200.608 150.543c.064.058.126.117.188.176a.5.5 0 0 1 .063.462 2.114 2.114 0 0 1-.8 1.548 2.265 2.265 0 0 1-1.5.054 1.74 1.74 0 0 0-1.465.206 5.562 5.562 0 0 1 2.247 3.045 2.624 2.624 0 0 1-1.068 2.884 4.6 4.6 0 0 1 1.924 1.573 1.639 1.639 0 0 1 .336 1.494 1.687 1.687 0 0 1-1.3.848 8.939 8.939 0 0 1-2 .15 21.6 21.6 0 0 1-4.743-.6 3 3 0 0 1 2.477-3.088 2.626 2.626 0 0 1-.759-.887l-.995-1.59a11.619 11.619 0 0 1-.88-1.59 8.707 8.707 0 0 1-.557-3.661 3.549 3.549 0 0 1 .563-2.109 3.453 3.453 0 0 1 1.525-.973c.279-.111.528-.266.8-.373.111-.043.9-.1.917-.126a3.39 3.39 0 0 1 2.044-1.511l-.059 1.732a.319.319 0 0 0 .213.364 17.342 17.342 0 0 1 2.829 1.972",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3517",
    d: "M283.5 144.2a10.177 10.177 0 0 1-2.872-5.179c.343.018 1.523-.313 1.21-.839-.155-.26-.424-.277-.692-.3-.139-.013-.924-.108-1 .044a4.715 4.715 0 0 0 .62-2.53 1.8 1.8 0 0 0-1.667-1.646h-.013a1.8 1.8 0 0 0-1.667 1.646 4.715 4.715 0 0 0 .62 2.53c-.071-.151-.858-.056-1-.044-.268.024-.537.04-.691.3-.314.526.866.857 1.209.839a10.173 10.173 0 0 1-2.872 5.179c-.439.424-.962 1.026-.661 1.557a1.2 1.2 0 0 0 .5.423 10.671 10.671 0 0 0 4.553.932h.013a10.675 10.675 0 0 0 4.554-.932 1.2 1.2 0 0 0 .5-.423c.314-.531-.208-1.137-.648-1.557",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3518",
    d: "M323.873 149.841a10.184 10.184 0 0 1-2.873-5.179c.343.018 1.524-.312 1.21-.839-.156-.261-.424-.277-.692-.3-.138-.013-.924-.108-1 .044a4.7 4.7 0 0 0 .62-2.53 1.8 1.8 0 0 0-1.667-1.646h-.013a1.8 1.8 0 0 0-1.667 1.646 4.706 4.706 0 0 0 .619 2.53c-.071-.151-.857-.056-1-.044-.267.024-.537.04-.692.3-.313.526.867.857 1.21.839a10.184 10.184 0 0 1-2.872 5.179c-.439.424-.962 1.026-.662 1.557a1.215 1.215 0 0 0 .505.423 10.671 10.671 0 0 0 4.553.932h.013a10.668 10.668 0 0 0 4.553-.932 1.208 1.208 0 0 0 .5-.423c.311-.53-.212-1.13-.651-1.557",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3519",
    d: "M318.552 139.5a10.166 10.166 0 0 1-2.872-5.179c.343.018 1.524-.313 1.21-.839-.155-.26-.425-.276-.692-.3-.139-.012-.924-.107-1 .044a4.715 4.715 0 0 0 .62-2.53 1.8 1.8 0 0 0-1.667-1.646h-.013a1.8 1.8 0 0 0-1.667 1.646 4.715 4.715 0 0 0 .62 2.53c-.072-.151-.857-.056-1-.044-.267.025-.537.041-.692.3-.314.527.868.857 1.21.839a10.184 10.184 0 0 1-2.872 5.179c-.44.424-.962 1.026-.662 1.557a1.214 1.214 0 0 0 .5.423 10.667 10.667 0 0 0 4.553.931h.013a10.667 10.667 0 0 0 4.553-.931 1.208 1.208 0 0 0 .505-.423c.31-.531-.212-1.133-.652-1.557",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3520",
    d: "M233.9 149.528a10.173 10.173 0 0 1-2.872-5.179c.343.018 1.523-.313 1.209-.839-.155-.26-.424-.277-.691-.3-.139-.013-.924-.108-1 .044a4.715 4.715 0 0 0 .62-2.53 1.8 1.8 0 0 0-1.667-1.646h-.013a1.8 1.8 0 0 0-1.667 1.646 4.715 4.715 0 0 0 .62 2.53c-.072-.151-.857-.056-1-.044-.267.024-.537.04-.692.3-.313.526.866.857 1.21.839a10.184 10.184 0 0 1-2.872 5.179c-.439.424-.962 1.026-.661 1.557a1.207 1.207 0 0 0 .5.423 10.668 10.668 0 0 0 4.553.932h.013a10.683 10.683 0 0 0 4.553-.932 1.208 1.208 0 0 0 .505-.423c.308-.531-.214-1.133-.653-1.557",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3521",
    d: "M216.684 155.011a10.178 10.178 0 0 1-2.873-5.179c.344.018 1.524-.313 1.21-.839-.155-.26-.424-.276-.691-.3-.138-.012-.925-.108-1 .044a4.706 4.706 0 0 0 .62-2.53 1.8 1.8 0 0 0-1.667-1.646h-.013a1.8 1.8 0 0 0-1.667 1.646 4.705 4.705 0 0 0 .619 2.53c-.071-.151-.857-.056-1-.044-.268.025-.538.041-.692.3-.314.526.867.857 1.21.839a10.184 10.184 0 0 1-2.872 5.179c-.439.424-.962 1.026-.661 1.557a1.2 1.2 0 0 0 .506.423 10.662 10.662 0 0 0 4.552.931h.013a10.67 10.67 0 0 0 4.553-.931 1.217 1.217 0 0 0 .506-.423c.309-.531-.214-1.133-.653-1.557",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3522",
    d: "M299.622 159.268a6.249 6.249 0 0 1-2.987-6.759c.568.206 1.143-.543.929-1.11a1.339 1.339 0 0 0-1.515-.7 2.571 2.571 0 0 0-.3-4.426 1.439 1.439 0 0 0 .375-1.5 1.338 1.338 0 0 0-1.884-.17 1.367 1.367 0 0 0-.17.17 1.443 1.443 0 0 0 .375 1.5 2.571 2.571 0 0 0-.3 4.426 1.341 1.341 0 0 0-1.515.7c-.213.567.36 1.316.93 1.11a6.248 6.248 0 0 1-2.987 6.759c-.629.343-1.446.793-1.326 1.5a1.425 1.425 0 0 0 .673.839 9.443 9.443 0 0 0 4.9 1.689v.018c.094 0 .189-.007.283-.009s.188.01.285.009v-.014a9.446 9.446 0 0 0 4.9-1.689 1.423 1.423 0 0 0 .672-.839c.109-.707-.709-1.156-1.338-1.5",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3523",
    d: "M228.76 159.293a6.453 6.453 0 0 1-3.084-6.978c.588.212 1.181-.561.96-1.146a1.383 1.383 0 0 0-1.564-.726 2.653 2.653 0 0 0-.313-4.569 1.49 1.49 0 0 0 .387-1.549 1.381 1.381 0 0 0-2.12 0 1.49 1.49 0 0 0 .387 1.549 2.654 2.654 0 0 0-.314 4.569 1.383 1.383 0 0 0-1.564.726c-.22.585.372 1.358.959 1.146a6.45 6.45 0 0 1-3.084 6.978c-.649.355-1.494.819-1.369 1.549a1.474 1.474 0 0 0 .695.866 9.741 9.741 0 0 0 5.057 1.744v.019c.1 0 .2-.007.293-.009s.2.01.293.009v-.019a9.738 9.738 0 0 0 5.057-1.744 1.47 1.47 0 0 0 .695-.866c.123-.73-.721-1.194-1.371-1.549",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3524",
    d: "M308.738 144.107a3.85 3.85 0 0 1-.255-.318 6.794 6.794 0 0 1-1.027-1.865 17.745 17.745 0 0 1-.822-7.022 15.443 15.443 0 0 1-4.662.128 35.829 35.829 0 0 1-.576 6.611 3.924 3.924 0 0 1-1.173 2.509c-.423.407-.924.986-.636 1.5a1.163 1.163 0 0 0 .486.406 11.172 11.172 0 0 0 8.765 0 1.16 1.16 0 0 0 .485-.406c.29-.515-.2-1.089-.585-1.543",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3525",
    d: "m305.86 131.914.024.942a5.141 5.141 0 0 1-1-.011l-.039-.762a16.763 16.763 0 0 0-2.16-.1l-.061.8-.7.041a2.754 2.754 0 0 1-.152-.867l-1.362-.124a25.5 25.5 0 0 1 .3 3.544 11.278 11.278 0 0 0 7.133.2l.02-3.811z",
    style: {
      fill: "#e3d8de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3526",
    d: "M245.52 154.29a4.393 4.393 0 0 1-.257-.318 6.817 6.817 0 0 1-1.026-1.865 17.746 17.746 0 0 1-.823-7.022 15.443 15.443 0 0 1-4.662.128 36 36 0 0 1-.575 6.611 3.93 3.93 0 0 1-1.177 2.509c-.422.407-.924.986-.635 1.5a1.163 1.163 0 0 0 .486.406 11.169 11.169 0 0 0 8.764 0 1.166 1.166 0 0 0 .487-.406c.29-.515-.2-1.089-.585-1.543",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3527",
    d: "m242.641 142.1.025.942a5.141 5.141 0 0 1-1-.011l-.039-.762a16.76 16.76 0 0 0-2.16-.1l-.06.8-.7.041a2.755 2.755 0 0 1-.152-.867l-1.362-.124a25.651 25.651 0 0 1 .3 3.544 11.281 11.281 0 0 0 7.134.2l.019-3.811z",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3528",
    d: "M208.671 130.808a9.847 9.847 0 0 1-3.813-4.282c.328-.056 1.374-.62.965-1.05a.75.75 0 0 0-.718-.137c-.133.018-.9.1-.931.253a4.553 4.553 0 0 0 .047-2.522 1.74 1.74 0 0 0-1.924-1.2h-.012a1.744 1.744 0 0 0-1.225 1.91 4.556 4.556 0 0 0 1.123 2.259c-.1-.128-.822.129-.95.171-.248.08-.5.152-.59.431-.185.564 1 .625 1.322.536a9.869 9.869 0 0 1-1.614 5.5c-.325.494-.691 1.174-.294 1.612a1.17 1.17 0 0 0 .567.292 10.338 10.338 0 0 0 4.5-.089h.013a10.331 10.331 0 0 0 4.1-1.849 1.17 1.17 0 0 0 .388-.507c.173-.563-.45-1.021-.954-1.328",
    style: {
      fill: "#2b211a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3529",
    d: "M184.767 119.907a5.81 5.81 0 0 1 .815-1.607c3.826-5.207 10.283-9.131 16.8-9.249 1.579-.029 3.52.419 3.929 1.946.151.566.044 1.171.149 1.747.265 1.46 1.729 2.314 2.933 3.181s2.364 2.366 1.723 3.7a11.329 11.329 0 0 0-.594 1.031c-.649 1.823 1.334 3.739.336 5.775a1.836 1.836 0 0 1-1.951 1.06 3.4 3.4 0 0 1-.97-.492c-2.121-1.326-5.251-2.385-7.357-.806-2.8 2.1-6.016 3.865-9.507 4.107a5.277 5.277 0 0 1-3.055-.54 6.075 6.075 0 0 1-2.121-2.631 11.626 11.626 0 0 1-1.476-5.047 6.781 6.781 0 0 1 .346-2.175",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3530",
    d: "M84.557 71.474c-2.891 6.377-2.447 13.791-.853 20.609 6.065 25.951 27.017 45.67 48.773 61.03 4.037 2.85 8.375 5.564 13.488 5.525 8.99-.069 17.68-3.608 25.188-8.561s13.987-11.288 20.415-17.582a2.433 2.433 0 0 0 .757-3.355 2.486 2.486 0 0 0-.282-.365l-6.81-11.824a357.862 357.862 0 0 1-34.322 13.068 15.74 15.74 0 0 1-5.518 1.061c-5.3-.252-7.609-9.079-9.726-13.145a186 186 0 0 1-8.4-18.1c-2.7-6.9-4.826-14.081-8.55-20.484C111.6 67.1 93.614 51.5 84.557 71.474",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3531",
    d: "M178.431 144.057c-5.608 2.8-11.35 5.314-17.059 7.9a28.976 28.976 0 0 1-8.887 2.769 19.092 19.092 0 0 1-8.033-.918 37.133 37.133 0 0 1-7.7-3.807 143.94 143.94 0 0 1-8.47-5.62 80.77 80.77 0 0 1-13.947-13.008c-4.316-5.015-8.016-10.5-12.208-15.607-4.173-5.085-8.732-9.886-12.353-15.4a55.678 55.678 0 0 1-6.68-15.073 60.34 60.34 0 0 1-.618-2.319 45.344 45.344 0 0 0 1.224 9.109c6.066 25.951 27.017 45.67 48.774 61.03 4.037 2.85 8.375 5.564 13.487 5.525 8.991-.069 17.681-3.608 25.188-8.561a89.307 89.307 0 0 0 9.059-6.941c-.589.3-1.178.623-1.776.921",
    style: {
      fill: "#99a834"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3532",
    d: "M341.492 104.78c-2.614 6.374-4.758 13.352-3.264 20.078a10.17 10.17 0 0 0 1.672 3.974 9.641 9.641 0 0 0 4.125 2.945c4.474 1.829 10.188 1.281 13.382-2.349 2.644-3 3.059-7.309 3.349-11.3q1.1-15.083 2.193-30.167c-3.994-1.514-13.033-4.563-15.358-.457-1.371 2.418-1.648 6.391-2.691 9.091-1.066 2.754-2.286 5.45-3.408 8.185",
    style: {
      fill: "#473b8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3533",
    d: "M343.989 79.427a7.807 7.807 0 0 0-.524 3.378 5.249 5.249 0 0 0 2.747 3.618 15.507 15.507 0 0 0 4.455 1.447l8.605 1.859a4.077 4.077 0 0 0 3.16-.18 2.856 2.856 0 0 0 1.085-2.133c.229-2.53-1.672-4.864-3.964-5.954s-4.909-1.2-7.444-1.3a18.541 18.541 0 0 0-3.709-9.2c-1.863-2.42-1.83.213-2.21 1.4-.755 2.347-1.466 4.71-2.2 7.065",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3534",
    d: "M349.61 73.469a10.882 10.882 0 0 1 .213 3.128 14.315 14.315 0 0 1-.555 3.1 10.722 10.722 0 0 1-1.025 2.417h.469c1.532-.016 3.067-.083 4.6.026a16.549 16.549 0 0 1 2.272.312 15.169 15.169 0 0 1 2.146.643 17.23 17.23 0 0 1 3.72 1.884 10.865 10.865 0 0 1 2.061 1.791 6.649 6.649 0 0 0-3.957-5.311c-2.292-1.09-4.909-1.2-7.444-1.3a18.509 18.509 0 0 0-2.951-8.053 7.115 7.115 0 0 1 .451 1.363",
    style: {
      fill: "#e7a579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 139",
    transform: "translate(383.924 84.715)",
    style: {
      fill: "#e7a579"
    },
    d: "M0 .239.238 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3535",
    d: "M352.957 146.5a18.729 18.729 0 0 0-7.068-1.48 17.343 17.343 0 0 0-5.544 1.527q-3.15 1.288-6.227 2.754c-.309.148-.66.352-.7.693-.063.561.7.785 1.262.794a87.153 87.153 0 0 0 9.613-.381 77.672 77.672 0 0 0-7.384 3.015c-1.432.673-2.958 1.509-3.545 2.98a52.122 52.122 0 0 0 8.335-1.487 3.987 3.987 0 0 0-2.218 1.751 34.415 34.415 0 0 0 7.877 1.1 29.562 29.562 0 0 1 4.3.215c1.548.263 3.013.874 4.528 1.285a18.02 18.02 0 0 0 5.875.589 4.429 4.429 0 0 0 1.8-.41c1.807-.96 1.776-3.556 1.245-5.533a8.73 8.73 0 0 0-1.476-3.263c-1.117-1.391-2.621-1.442-4.19-1.88-2.189-.613-4.337-1.518-6.483-2.269",
    style: {
      fill: "#f4bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3536",
    d: "M404.233 78.462c-11.64 8.262-5.554 32.136-3.227 43.732.562 2.8 1.114 5.862-.209 8.392a9.788 9.788 0 0 1-2.729 3.031c-4.3 3.38-9.647 5.06-14.869 6.674l-24.467 7.565a24.011 24.011 0 0 1 5.363 13l45.856-5.494c3.027-.363 6.184-.772 8.706-2.488 3.5-2.379 5.019-6.736 5.945-10.865 3.318-14.8 1.829-30.244-.653-45.049-1.433-8.551-7.626-27.075-19.716-18.5",
    style: {
      fill: "#473b8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3537",
    d: "M366.511 147.486a91.628 91.628 0 0 1 13.345-3.683c1.038-.2 2.085-.392 3.137-.5 1.333-.133 2.674-.126 4.013-.127.642 0 1.284 0 1.925-.026a7.829 7.829 0 0 0 1.943-.195 10.813 10.813 0 0 0 2.9-1.515c1.451-1.006 2.828-2.4 4.572-2.871a17.655 17.655 0 0 1 4.036-.5 8.515 8.515 0 0 0 3.086-.392 2.788 2.788 0 0 0 1.467-2.49 13.1 13.1 0 0 0-.06-2.656c-.1-1-.2-2.007-.336-3.005-.276-1.965-.671-3.912-1.129-5.842-.974-4.106-2.222-8.14-3.414-12.185-1.212-4.117-2.387-8.255-3.188-12.474a50.593 50.593 0 0 1-.961-8.993c-1.792 10.5 1.567 24.22 3.162 32.168.563 2.8 1.113 5.862-.21 8.392a9.763 9.763 0 0 1-2.729 3.031c-4.3 3.38-9.648 5.06-14.869 6.674l-24.467 7.565a23.592 23.592 0 0 1 1.488 2.041q3.11-1.3 6.289-2.417",
    style: {
      fill: "#5f55a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3538",
    d: "M423.949 96.961c-.862-5.145-3.451-13.894-8.007-18.184a27.832 27.832 0 0 1 3.531 7.5 64.809 64.809 0 0 1 2.5 13.138c.411 4.069.579 8.155.71 12.241.093 2.857-.031 5.716-.2 8.569-.179 3.1-.351 6.205-.654 9.291a31.636 31.636 0 0 1-3 11.41 19.92 19.92 0 0 1-6.528 7.342 37.328 37.328 0 0 1-10.583 4.675 113.768 113.768 0 0 1-17.229 3.446c-6.881.922-13.795 1.558-20.659 2.607.108.616.2 1.234.258 1.857l45.856-5.494c3.026-.363 6.184-.772 8.706-2.488 3.5-2.379 5.019-6.736 5.945-10.865 3.322-14.792 1.831-30.24-.651-45.045",
    style: {
      fill: "#362985"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroGames);
export default __webpack_public_path__ + "static/media/hero-games.0bb7e2949b9f75c51e2a67d9e853c2f9.svg";
export { ForwardRef as ReactComponent };